import { Text } from "ui/Typography"
import styles from "./ExtraGuessPriceItem.module.css"
import { colors } from "themes/variables"
import { InfoTooltip } from "ui/Tooltip/InfoTooltip"
import { Form, InputNumber } from "antd"
import PropTypes from "prop-types"

export const ExtraGuestPriceItem = ({ name, text, subText, infoText, required }) => {
  const rules = required ? [{ required: true, message: "Cannot be blank" }] : []
  
  return (
    <div className={styles.wrapper}>
      <div className={styles.typeWrapper}>
        <Text variant="body" size="md">
          {text}
        </Text>
        {subText && (
          <Text variant="body" size="md" color={colors.textSecondaryDark}>
            ({subText})
          </Text>
        )}
        {infoText && <InfoTooltip title={infoText} />}
      </div>
      <Form.Item name={name} className="mb-0 w-100" rules={rules}>
        <InputNumber prefix="$" size="large" min={0} className={styles.input} />
      </Form.Item>
    </div>
  )
}
ExtraGuestPriceItem.propTypes = {
  name: PropTypes.string,
  text: PropTypes.string.isRequired,
  subText: PropTypes.string,
  infoText: PropTypes.string,
  required: PropTypes.bool,
};
